export const baseStyles = {
    color: `#669bd2`,
    fontWeight: 900,
};
